<template>
  <div class="flex flex-wrap justify-center">
    <a
      class="flex items-center justify-center cursor-pointer hover:bg-gray-100"
      v-for="(application, slug) in applications"
      :key="slug"
      @click="setApplication(application, slug)"
    >
      <div class="flex flex-col justify-start items-center w-20 p-2 m-2">
        <div class="w-12 h-12">
          <img
            :src="'/assets/imgs/software/' + slug + '/icon.png'"
            alt=""
            width="100%"
            height="100%"
          />
        </div>
        <div
          class="whitespace-no-wrap text-sm text-gray-800 pt-2"
          v-text="application"
        ></div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: ["applications"],
  components: {},
  methods: {
    setApplication(application, slug) {
      this.$emit("application-selected", { name: application, slug: slug });
    },
  },
};
</script>
